import { Grid, LinearProgress, Theme, Typography } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { TechnicalChangelogButton } from "features/use-case";
import { ReleaseType } from "model/schema/globalTypes";
import React, { useState } from "react";
import { QueryNewWebServicePreview_solutions_Solutions_solution_Solution_useCases_UseCasesViewModel_calculationRule_CalculationRuleViewModel_schema_UseCaseSchema as QueryNewWebServicePreview_solutions_solution_useCases_calculationRule_schema } from "./hooks/schema/QueryNewWebServicePreview";
import {
  QueryUpgradeWebservicePreview_solutions_Solutions_solution_Solution_useCases_UseCasesViewModel_useCase_UseCaseViewModel_detail_UseCaseDetail_nextVersion_NextVersion_schema_UseCaseSchema as QueryUpgradeWebservicePreview_solutions_solution_useCases_useCase_detail_nextVersion_schema,
  QueryUpgradeWebservicePreview_solutions_Solutions_solution_Solution_useCases_UseCasesViewModel_useCase_UseCaseViewModel_detail_UseCaseDetail_nextVersion_NextVersion_schemaDiff_SchemaDiffs as QueryUpgradeWebservicePreview_solutions_solution_useCases_useCase_detail_nextVersion_schemaDiff
} from "./hooks/schema/QueryUpgradeWebservicePreview";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    progress: {
      margin: theme.spacing(2),
      width: "100%"
    },
    version: {
      color: "#B1B1B1"
    },
    rowMargin: { margin: theme.spacing(2, 0) }
  })
);

type PreviewSchema =
  | QueryNewWebServicePreview_solutions_solution_useCases_calculationRule_schema
  | QueryUpgradeWebservicePreview_solutions_solution_useCases_useCase_detail_nextVersion_schema;

type PreviewSchemaDiff =
  QueryUpgradeWebservicePreview_solutions_solution_useCases_useCase_detail_nextVersion_schemaDiff;

type ChangesPreviewProps = {
  loading?: boolean;
  releaseType: ReleaseType;
  schema?: PreviewSchema | null;
  schemaDiff?: PreviewSchemaDiff | null;
  version: string;
};

const ChangesPreview: React.FC<ChangesPreviewProps> = ({
  loading,
  releaseType,
  schema,
  schemaDiff,
  version
}) => {
  const classNames = useStyles();
  const [isChangelogOpened, setIsChangelogOpened] = useState(false);
  const toggleChangelog = () => setIsChangelogOpened(!isChangelogOpened);

  if (loading) {
    return <LinearProgress className={classNames.progress} />;
  }

  if (!schema) {
    return null;
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} container alignItems="center">
        <Grid item xs={6}>
          <Typography className={classNames.version}>
            Expected next version
          </Typography>
        </Grid>
        <Grid item xs={6} alignItems="center">
          <Typography className={classNames.version}>{version}</Typography>
        </Grid>
      </Grid>

      <Grid item xs={12} container alignItems="center">
        <Grid item xs={6}>
          <Typography className={classNames.version}>
            Expected release type
          </Typography>
        </Grid>
        <Grid item xs={6} alignItems="center">
          <Typography className={classNames.version}>{releaseType}</Typography>
        </Grid>
      </Grid>

      <Grid item xs={12} container alignItems="center">
        <Grid item xs={6}>
          <Typography variant="subtitle2">Show Changes</Typography>
        </Grid>
        <Grid item xs={6}>
          <TechnicalChangelogButton
            schemaDiff={schemaDiff}
            schema={schema}
            isChangelogOpened={isChangelogOpened}
            toggleChangelog={toggleChangelog}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ChangesPreview;
